import { useCallback, useContext } from "react";

import type { UserRole } from "@/api/types";
import { AuthContext, type AuthState } from "./auth-context";

/** Roles allowed to change stock. Mirrors WRITE_ROLES on the backend. */
export const WRITE_ROLES: UserRole[] = [
  "ADMIN",
  "MANAGER",
  "TECHNICIAN",
  "EMPLOYEE",
  "SERVICE_DEVICE",
];

export function useAuth(): AuthState {
  const context = useContext(AuthContext);
  if (!context) throw new Error("useAuth must be used inside an AuthProvider");
  return context;
}

/**
 * True when the current user may change stock.
 *
 * Hiding a button the server would refuse is a courtesy, not a security
 * boundary — permissions are enforced server-side regardless.
 */
export function useCanWrite(): boolean {
  const { can } = useAuth();
  const check = useCallback(() => can(...WRITE_ROLES), [can]);
  return check();
}
